var React = require('react');

function SoccerShoe60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M55.035 24.999h-5.139v2a.998.998 0 1 1-1.997 0v-2h-5.991v2a.998.998 0 1 1-1.997 0v-2H33.92v2a.999.999 0 1 1-1.997 0v-2H16.945v2a.998.998 0 1 1-1.997 0v-2H8.957v2a.999.999 0 1 1-1.997 0v-2h-.05c-2.329 0-4.009-.558-5.138-1.707-1.893-1.928-1.842-5.081-1.78-8.732.011-.668.022-1.356.022-2.06C.014 6.733 1.792-.001 6.8-.001c2.212 0 3.362 1.038 4.378 1.953C12.347 3.005 13.45 4 16.444 4c3.266 0 4.747-1.229 6.055-2.313 1-.828 2.035-1.688 3.591-1.688 1.728 0 3.05 1.071 4.724 2.426 1.826 1.476 4.098 3.315 8.014 4.936 1.961.812 4.23 1.629 6.633 2.492 8.973 3.227 14.421 5.402 14.421 8.396 0 3.008 0 6.75-4.847 6.75zM29.559 3.98c-1.473-1.193-2.447-1.981-3.469-1.981-.8 0-1.345.422-2.318 1.229C22.361 4.398 20.429 6 16.444 6c-3.759 0-5.336-1.42-6.602-2.562-.927-.835-1.597-1.439-3.042-1.439-3.29 0-4.789 5.444-4.789 10.501 0 .715-.011 1.415-.022 2.093-.054 3.202-.099 5.966 1.207 7.297.733.746 1.948 1.11 3.714 1.11h12.195L31.011 5.13a72.551 72.551 0 0 1-1.452-1.15zm3.075 2.317L21.506 23h5.316l9.649-14.502a29.696 29.696 0 0 1-3.837-2.201zm5.695 3.015L29.222 23h5.316l8.033-12.07a119.817 119.817 0 0 1-4.242-1.618zm6.457 2.424l-.283-.103L36.938 23h18.097c2.495 0 2.85-1.013 2.85-4.751 0-1.803-8.2-4.751-13.099-6.513z","key":1})]);
}

SoccerShoe60px.displayName = "SoccerShoe60px";

SoccerShoe60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.88 28"};

module.exports = SoccerShoe60px;

SoccerShoe60px.default = SoccerShoe60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/soccer-shoe-60px.svg
// module id = 1205
// module chunks = 0